export default __webpack_public_path__ + "static/media/AmiyaBagchi.86c14044.jpg";